<script lang="ts">
  // Four audience-targeted home/login variants. Choose with ?home=motion|events|landing|imagery
  // (persisted per browser); default is the audience-tabbed landing. Each variant
  // is code-split so only the chosen one loads (and none load for signed-in users).
  import Lazy from '../components/Lazy.svelte';

  type Variant = 'motion' | 'events' | 'landing' | 'imagery';
  const VALID: Variant[] = ['motion', 'events', 'landing', 'imagery'];
  const LOADERS: Record<Variant, () => Promise<unknown>> = {
    motion: () => import('./home/Motion.svelte'),
    events: () => import('./home/Events.svelte'),
    imagery: () => import('./home/Imagery.svelte'),
    landing: () => import('./home/Landing.svelte'),
  };

  function pickVariant(): Variant {
    try {
      const q = new URLSearchParams(location.search).get('home') as Variant | null;
      if (q && VALID.includes(q)) return q;
    } catch (_) {}
    return 'landing';   // the audience-tabbed landing is the front door
  }
  const variant = pickVariant();
</script>

<!-- Every pre-auth screen (all home variants) is pinned to the dark brand look at the
     default size in Jakarta Sans, regardless of the signed-in appearance prefs. -->
<div data-force-dark style="display: contents"><Lazy load={LOADERS[variant]} /></div>
